export const TRACKING_PAGE_ACCESS_CARD = {
  title: 'How customers reach your tracking page',
  subtitle: 'You only need to set up one of these.',
  option1Label: 'Option 1 · Direct link',
  option2Label: 'Option 2 · Add app block to theme',
  option3Label: 'Option 3 · Add it manually',
  option3Description:
    'Paste this where you want the tracking lookup to appear — in a custom Liquid block, page, or section.',
  trackingPageLinkLabel: 'Tracking page link',
  embedCodeLabel: 'Embed code',
  embedCode: '<div id="omega-order-lookup"></div>',
  copyLabel: 'Copy link',
  copyCodeLabel: 'Copy code',
  copiedLabel: 'Copied',
  openLabel: 'Open tracking page',
  activeLabel: 'Active',
  manageCta: 'Manage',
  addCta: 'Add',
};
